export default __webpack_public_path__ + "static/media/warning.30c0e59f.svg";